import React from 'react';
import { Box, Typography } from '@mui/material';

export default function ReportDashboard() {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>Report Dashboard</Typography>
      <Typography variant="body2" color="text.secondary">
        Analytics and report summaries.
      </Typography>
    </Box>
  );
}
